export default __webpack_public_path__ + "static/media/kiosk.ee1d7ed8.svg";